import request from "../utils/request";

export function GET_MeetingList(token, projectId) {
  return request.get(`/Meeting/List/${projectId}`, null, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export function POST_Meeting(token, projectId, formData) {
  return request.post(`/Meeting/${projectId}`, formData, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

export function PUT_Meeting(token, meetingId, formData) {
  return request.put(`/Meeting/${meetingId}`, formData, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
  });
}

export function DELETE_Meeting(token, meetingId) {
  return request.delete(`/Meeting/${meetingId}`, null, {
    headers: { Authorization: `Bearer ${token}` },
  });
}
